import { render, staticRenderFns } from "./mr-empty.vue?vue&type=template&id=5359457b&scoped=true"
import script from "./mr-empty.vue?vue&type=script&lang=js"
export * from "./mr-empty.vue?vue&type=script&lang=js"
import style0 from "./mr-empty.vue?vue&type=style&index=0&id=5359457b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5359457b",
  null
  
)

export default component.exports